<template>
  <div>
    <div class="user-form">
      <div class="steps">
        <div class="steps-line-box">
          <div class="steps-line" style="width:65%;"></div>
        </div>
        <ul class="steps-ul">
          <li class="active">{{ $t("lang.steps1") }}</li>
          <li class="active">{{ $t("lang.steps2") }}</li>
          <li>{{ $t("lang.steps3") }}</li>
          <li>{{ $t("lang.steps4") }}</li>
        </ul>
      </div>
      <el-form
        ref="userinfoParam"
        :model="userinfoParam"
        autoComplete="off"
        :rules="formRules"
      >
        <div class="form-box">
          <el-form-item prop="id" style="display:none">
            <el-input v-model="userinfoParam.id" type="hidden"></el-input>
          </el-form-item>
          <div class="form-label" v-if="language === 'cn'">
            <label class="labels"
              ><span>*</span>所授科目</label
            >
            <el-form-item prop="subjectType">
              <el-radio-group v-model="userinfoParam.subjectType" size="small">
                <el-radio label="1" v-if="haveChineseClassic">传统文化</el-radio>
                <el-radio label="2" v-if="haveChinese">语文</el-radio>
                <el-radio label="3" v-if="haveMath">数学</el-radio>
                <el-radio label="4" v-if="haveMusic">音乐</el-radio>
                <el-radio label="5" v-if="haveArt">美术</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="form-label">
            <label class="labels"
              ><span>*</span>{{ $t("lang.userPage1") }}</label
            >
            <el-form-item prop="name">
              <el-input
                v-model="userinfoParam.name"
                type="text"
                :placeholder="$t('lang.userPage1')"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </div>
          <div class="form-label">
            <label class="labels"
              ><span>*</span>{{ $t("lang.userPage2") }}</label
            >
            <el-form-item prop="birthday">
              <el-date-picker
                v-model="userinfoParam.birthday"
                type="date"
                :placeholder="$t('lang.userPage3')"
                :picker-options="pickerOptionsBefore"
              >
              </el-date-picker>
            </el-form-item>
          </div>
          <div class="form-label">
            <label class="labels"
              ><span>*</span>{{ $t("lang.userPage4") }}</label
            >
            <el-form-item prop="gender">
              <el-radio-group v-model="userinfoParam.gender">
                <el-radio label="0">{{ $t("lang.userPage5") }}</el-radio>
                <el-radio label="1">{{ $t("lang.userPage6") }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="form-label" v-if="language === 'en'">
            <label class="labels"
              ><span>*</span>{{ $t("lang.userPage7") }}</label
            >
            <div class="tel-box">
              <el-form-item prop="phone">
                <el-input
                  v-model.number="userinfoParam.phone"
                  type="text"
                  :placeholder="$t('lang.userPage7')"
                  auto-complete="off"
                ></el-input>
              </el-form-item>
            </div>
            <div class="select-box width-180">
              <el-form-item prop="phoneCode">
                <el-select
                  v-model="userinfoParam.phoneCode"
                  :placeholder="$t('lang.userPage8')"
                >
                  <template v-if="language === 'en'">
                    <el-option
                      v-for="item in countryCodes"
                      :key="item.id"
                      :label="item.english"
                      :value="item.code"
                    >
                    </el-option>
                  </template>
                  <template v-else>
                    <el-option
                      v-for="item in countryCodes"
                      :key="item.id"
                      :label="item.chinese"
                      :value="item.code"
                    >
                    </el-option>
                  </template>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div class="form-label" v-if="language === 'en'">
            <label class="labels"
              ><span>*</span>{{ $t("lang.userPage9") }}</label
            >
            <el-form-item prop="skype">
              <el-input
                v-model="userinfoParam.skype"
                type="text"
                :placeholder="$t('lang.userPage9')"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </div>
          <div class="form-label">
            <label class="labels"
              ><span>*</span>{{ $t("lang.userPage10") }}</label
            >
            <div class="select-box">
              <el-form-item prop="nationality">
                <el-select
                  v-model="userinfoParam.nationality"
                  :placeholder="$t('lang.userPage12')"
                  @change="getCountryId($event)"
                >
                  <el-option
                    v-for="item in nationalityList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div class="form-label">
            <label class="labels"
              ><span>*</span>{{ $t("lang.userPage11") }}</label
            >
            <div class="select-box">
              <el-form-item prop="certificate">
                <el-select
                  v-model="userinfoParam.certificate"
                  :placeholder="$t('lang.userPage13')"
                >
                  <el-option
                    v-for="item in certificate"
                    :key="item.id"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="user-info-more">
          <h1>{{ $t("lang.userPage14") }}</h1>
        </div>
        <div class="form-box">
          <div class="form-label">
            <label class="labels">{{ $t("lang.userPage15") }}</label>
            <el-form-item prop="organizationName">
              <el-input
                v-model="userinfoParam.organizationName"
                type="text"
                :placeholder="$t('lang.userPage15')"
                auto-complete="off"
                :maxlength="60"
              ></el-input>
            </el-form-item>
          </div>
          <div class="form-label">
            <label class="labels">{{ $t("lang.userPage16") }}</label>
            <el-form-item prop="jobTitle">
              <el-input
                v-model="userinfoParam.jobTitle"
                type="text"
                :placeholder="$t('lang.userPage16')"
                auto-complete="off"
                :maxlength="30"
              ></el-input>
            </el-form-item>
          </div>
          <div class="form-label">
            <label class="labels">{{ $t("lang.userPage17") }}</label>
            <el-form-item prop="workTime">
              <el-time-picker
                is-range
                arrow-control
                v-model="userinfoParam.workTime"
                range-separator="To"
                :start-placeholder="$t('lang.userPage21')"
                :end-placeholder="$t('lang.userPage22')"
                placeholder="Select a time range"
              >
              </el-time-picker>
            </el-form-item>
          </div>
          <div class="form-label">
            <label class="labels">{{ $t("lang.userPage18") }}</label>
            <el-form-item prop="hoursPerWeek">
              <el-input
                v-model.number="userinfoParam.hoursPerWeek"
                type="text"
                :placeholder="$t('lang.userPage34')"
                auto-complete="off"
                :maxlength="3"
              ></el-input>
            </el-form-item>
          </div>
          <div class="form-label">
            <label class="labels">{{ $t("lang.userPage19") }}</label>
            <el-form-item prop="introduction">
              <el-input
                v-model="userinfoParam.introduction"
                type="textarea"
                :placeholder="$t('lang.userPage35')"
                auto-complete="off"
                :maxlength="500"
                :minlength="4"
                resize="none"
              ></el-input>
            </el-form-item>
          </div>
          <div class="form-label text-align-center">
            <div class="btn-tip">* {{ $t("lang.userPage20") }}</div>
            <el-button
              class="btn"
              :loading="btnLoading"
              @click="_CheckUserInfo"
              >{{ $t("lang.loginPage15") }}</el-button
            >
          </div>
        </div>
      </el-form>
    </div>
    <div class="app-bg"></div>
  </div>
</template>
<script>
import AppHeader from "components/app-header/app-header";
import { getNationalityList, getSubjectList, checkUserInfo } from "api/me";
import { ERR_OK } from "api/config";
import countryCodes from "utils/countryCodes";
import moment from "moment-timezone";

export default {
  data() {
    return {
      language: localStorage.getItem("language"),
      btnLoading: false,
      pickerOptionsBefore: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      nationalityList: [],
      subjectList: [],
      countryCodes: countryCodes,
      certificate: [
        this.$t("lang.userPage36"),
        this.$t("lang.userPage37"),
        this.$t("lang.userPage38"),
        this.$t("lang.userPage39"),
        this.$t("lang.userPage40"),
        this.$t("lang.userPage41")
      ],
      countryId: 0,
      userinfoParam: {
        id: Number.parseInt(this.$route.query.teacherid),
        name: "",
        subjectType: localStorage.getItem("language") === "cn" ? "" : "0",
        birthday: "",
        gender: "",
        phoneCode: "",
        phone: "",
        skype: localStorage.getItem("language") === "cn" ? "暂无" : "",
        nationality: "",
        timezone: moment.tz.guess(),
        certificate: "",
        organizationName: "",
        jobTitle: "",
        startDate: "",
        endDate: "",
        workTime: "",
        hoursPerWeek: "",
        introduction: ""
      },
      formRules: {
        id: [
          {
            required: true
          }
        ],
        name: [
          {
            required: true,
            message: this.$t("lang.userPage23"),
            trigger: "blur"
          }
        ],
        birthday: [
          {
            required: true,
            type: "date",
            message: this.$t("lang.userPage24"),
            trigger: "change"
          }
        ],
        gender: [
          {
            required: true,
            message: this.$t("lang.userPage25"),
            trigger: "change"
          }
        ],
        phoneCode: [
          {
            required: true,
            message: this.$t("lang.userPage26"),
            trigger: "change"
          }
        ],
        phone: [
          {
            required: true,
            message: this.$t("lang.userPage31"),
            trigger: "blur"
          }
        ],
        skype: [
          {
            required: true,
            message: this.$t("lang.userPage27"),
            trigger: "blur"
          }
        ],
        nationality: [
          {
            required: true,
            message: this.$t("lang.userPage28"),
            trigger: "change"
          }
        ],
        certificate: [
          {
            required: true,
            message: this.$t("lang.userPage29"),
            trigger: "change"
          }
        ],
        introduction: [
          {
            min: 4,
            max: 500,
            message: this.$t("lang.userPage30"),
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    haveChineseClassic() {
      return this.subjectList.indexOf('CHINESE_CLASS') !== -1
    },
    haveChinese() {
      return this.subjectList.indexOf('CHINESE') !== -1
    },
    haveMath() {
      return this.subjectList.indexOf('MATH') !== -1
    },
    haveMusic() {
      return this.subjectList.indexOf('MUSIC') !== -1
    },
    haveArt() {
      return this.subjectList.indexOf('ART') !== -1
    }
  },
  created() {
    document.body.removeAttribute("class", "dialogfade");
    this._getNationalityList();
    this._getSubjectList();
    this._getUserInfo();
    this.initLanguage();
  },
  components: {
    AppHeader
  },
  methods: {
    getCountryId(event) {
      this.countryId = event;
      this.userinfoParam.nationality = this.nationalityList[event - 1].name;
    },
    _getNationalityList() {
      getNationalityList()
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              this.nationalityList = response.data.data;
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
    },
    _getSubjectList() {
      const params = {
        subjectShowType: 'TEACHER_CHOSE'
      }
      getSubjectList(params)
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === +ERR_OK) {
              this.subjectList = response.data.data;
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
    },
    initLanguage() {
      let lang = this.$i18n.locale
      localStorage.setItem("language", lang)
    },
    _CheckUserInfo() {
      // console.log(this.userinfoParam.phoneCode)
      this.$refs.userinfoParam.validate(valid => {
        if (valid) {
          if (this.userinfoParam.hoursPerWeek) {
            if (!Number.isInteger(this.userinfoParam.hoursPerWeek)) {
              this.$message.error(this.$t("lang.userPage32"));
              return false;
            }
          }
          this.btnLoading = true;
          checkUserInfo(this.userinfoParam)
            .then(response => {
              if (response.status !== 200) {
                this.$message.error(response.data.message);
              } else {
                if (response.data.code === ERR_OK) {
                  this.$router.push({ path: "/userAuth" });
                } else {
                  if (
                    response.data.message ===
                    "The phone number has already existed."
                  ) {
                    this.userinfoParam.phone = "";
                  }
                  this.$message.error(response.data.message);
                }
              }
              this.btnLoading = false;
            })
            .catch(e => {
              this.$message.error(e.message);
              this.btnLoading = false;
            });
        }
      });
    },
    _getUserInfo() {
      this.$store
        .dispatch("GetUserInfo")
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              this.userinfoParam.phone = response.data.data.phone;
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(() => {});
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~styles/variables.scss";
@import "~styles/mixin.scss";
.steps {
  width: 570px;
  height: 35px;
  position: relative;
  margin: 50px auto;
  .steps-line-box {
    width: 100%;
    height: 2px;
    position: absolute;
    top: 50%;
    margin-top: -1px;
    background-color: #bebebe;
    .steps-line {
      position: absolute;
      width: 0%;
      height: 2px;
      background-color: #b8e986;
    }
  }
  .steps-ul {
    position: relative;
    z-index: 2;
    li {
      display: inline-block;
      float: left;
      width: 116px;
      height: 31px;
      line-height: 31px;
      border: 2px solid #bebebe;
      background-color: #fff;
      color: #bebebe;
      border-radius: 20px;
      text-align: center;
      margin-left: 30px;
    }
    li:nth-child(1) {
      margin-left: 0px;
    }
    li.active {
      background-color: #b8e986;
      border: 2px solid #b8e986;
      color: #fff;
    }
  }
}
.user-form {
  width: 998px;
  border: 1px solid #dedede;
  background-color: $white;
  border-radius: 6px;
  margin: 40px auto;
}
.form-box {
  width: 600px;
  margin: 0 auto;
  .form-label {
    margin-bottom: 50px;
    @include clearfix;
    .labels {
      width: 200px;
      float: left;
      height: 36px;
      line-height: 36px;
      color: #333;
      span {
        color: red;
        position: relative;
        top: 3px;
        margin-right: 5px;
      }
    }
    input {
      width: 360px;
      float: right;
      height: 36px;
      background-color: #f5f5f5;
      border: 0;
      border-radius: 20px;
      padding: 0px 20px;
      outline: none;
      color: #bebebe;
    }
    ::-webkit-input-placeholder {
      color: #bebebe;
    }
    .select-box {
      width: 400px;
      float: left;
      .el-form-item {
        width: 100%;
      }
    }
    .tel-box {
      width: 200px;
      float: right;
      .el-form-item {
        width: 100%;
      }
    }
    .btn {
      display: inline-block;
      padding: 0px 100px;
    }
  }
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 400px;
}
.width-180 {
  width: 180px !important;
}
.user-info-more {
  width: 100%;
  border-top: 2px solid #dedede;
  h1 {
    font-size: 15px;
    color: #333;
    text-align: center;
    margin: 50px 0px 30px;
  }
}
.btn-tip {
  color: red;
  margin: 70px 0px 30px;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/me/user-info.vue